module.exports = __webpack_public_path__ + "assets/img/aboutUS-module6-9.ac73e1b6.jpg";